<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <!--    <div class="btn " @click="sina">sina</div>-->
    <div class="container-fluid">
      <a class="navbar-brand" href="#">داشبورد</a>
      <button class="navbar-toggler navbar-burger"
              type="button"
              @click="toggleSidebar"
              :aria-expanded="$sidebar.showSidebar"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"/>
        <span class="navbar-toggler-bar"/>
        <span class="navbar-toggler-bar"/>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav mr-auto">

          <drop-down alignmentIcon="right" class="nav-item"
                     title="تنظیمات"
                     title-classes="nav-link"
                     icon="fas fa-cog">
            <!-- <router-link :to="{name: 'home_settings'}" class="dropdown-item">صفحه اصلی</router-link> -->
            <router-link :to="{name: 'versions'}" class="dropdown-item">تنظیمات ورژن</router-link>

          </drop-down>
          <li class="nav-item ">
            <a @click.prevent="logout_user" class="nav-link text-danger font-16">
              <i class="fas fa-sign-out-alt" />
              خروج
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import {mapActions} from "vuex"

  export default {
    computed: {
      routeName() {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      }
    },
    data() {
      return {
        activeNotifications: false,
        ...mapActions('main', [
          'logout',
        ]),

      };
    },
    methods: {
      logout_user() {
        return this.logout()
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      }
    }
  };
</script>
<style>
</style>
